export enum AmbienteSitio {
    DEV = 1,
    QA = 2,
    PROD = 3
}
